import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { ClipLoader } from 'react-spinners'
import { useAppSelector } from '@/redux/hooks'

interface LoadingOverlayProps {
  loading: boolean
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading }) => {
  const overlayRef = useRef<HTMLDivElement>(null)

  const isMisako =
    useAppSelector(
      (store) => store.settingsApi.settings.response.ecommerce_group
    ) === 'misako'

  useEffect(() => {
    if (!loading) return
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const root = document.getElementById('root')
    root?.setAttribute('inert', '')
    overlayRef.current?.focus()
    return () => {
      document.body.style.overflow = previousOverflow
      root?.removeAttribute('inert')
    }
  }, [loading])

  if (!loading) return null

  return createPortal(
    <div
      ref={overlayRef}
      tabIndex={-1}
      role="alert"
      aria-label="Loading"
      className="fixed inset-0 z-[9999] flex items-center justify-center text-brand-700 outline-none backdrop-blur-[2px]"
    >
      {/* Misako suppresses the spinner, keeping only the blur blocker */}
      {isMisako ? null : (
        <ClipLoader color="currentColor" loading={loading} size="100px" />
      )}
      <span className="sr-only">Loading</span>
    </div>,
    document.body
  )
}
